<template>
  <div style="height: calc(100vh - 228px);overflow-y: auto;">
    <el-collapse v-if="trackData.length > 0" v-model="activeName" accordion>
      <el-collapse-item
        v-for="(orderItem, orderIndex) in trackData"
        :key="orderIndex"
        :title="orderItem.number"
        :name="orderIndex"
      >
        <template slot="title">
          <div style="display: flex; align-items: center;font-size: 16px;font-weight: bold;line-height: 18px">
            <span :class="orderItem.trackIcon" />
            <span style="margin-left: 10px; float: left">
              {{ orderItem.number }}
            </span>
            <span v-if="orderItem.nowTrack && orderItem.nowTrack.length > 0">
              <span v-if="orderItem.nowTrack[0].scanTime" style="margin-left: 10px">{{ orderItem.nowTrack[0].scanTime }}</span>
              <span style="margin-left: 10px">
                {{ orderItem.nowTrack[0].status }}
              </span>
              <span v-if="orderItem.nowTrack[0].siteName" style="margin-left: 10px">{{ $t('collectionCenter.site') }}:【{{ orderItem.nowTrack[0].siteName }}】</span>
              <span v-if="orderItem.nowTrack[0].signName" style="margin-left: 10px">{{ $t('collectionCenter.operator') }}:【{{ orderItem.nowTrack[0].signName }}】</span>
            </span>
            <span v-else-if="orderItem.vehicleNowTrack && orderItem.vehicleNowTrack.length > 0">
              <span v-if="orderItem.vehicleNowTrack[0].scanTime" style="margin-left: 10px">{{ orderItem.vehicleNowTrack[0].scanTime }}</span>
              <span style="margin-left: 10px">
                {{ orderItem.vehicleNowTrack[0].status }}
              </span>
              <span v-if="orderItem.vehicleNowTrack[0].siteName" style="margin-left: 10px">{{ $t('collectionCenter.site') }}:【{{ orderItem.vehicleNowTrack[0].siteName }}】</span>
              <span v-if="orderItem.vehicleNowTrack[0].driverName" style="margin-left: 10px">{{ $t('order.driver') }}:【{{ orderItem.vehicleNowTrack[0].driverName }}】</span>
            </span>
          </div>
        </template>
        <div style="padding-left: 20px;border-top: 1px solid #eee;padding-top: 15px" class="timelineItem">
          <el-timeline v-if="orderItem.trackStatuses && orderItem.trackStatuses.length > 0">
            <el-timeline-item
              v-for="(item, index) in orderItem.trackStatuses"
              :key="index"
              :color="index === 0 ? '#00A551' : ''"
              :timestamp="
                (item.scanTime ? item.scanTime : '') +
                  (item.status ? '；' + item.status : '') +
                  (item.siteName ? '；' + $t('collectionCenter.site') + '：【' + item.siteName + '】' : '') +
                  (item.signName ? '；' + $t('collectionCenter.operator') + '：【' + item.signName + '】' : '') +
                  (item.nextSiteName ? '；' + $t('GlobalSetObj.nextStation') + '：' + item.nextSiteName : '') +
                  (item.tagNum ? '；' + $t('collectionCenter.carNumber') + '：' + item.tagNum : '')"
            />
          </el-timeline>
          <el-timeline v-if="orderItem.vehicleTrack && orderItem.vehicleTrack.length > 0">
            <el-timeline-item
              v-for="(item, index) in orderItem.vehicleTrack"
              :key="index"
              :color="index === 0 ? '#00A551' : ''"
              :timestamp="
                (item.scanTime ? item.scanTime : '') +
                  (item.status ? '；' + item.status : '') +
                  (item.siteName ? '；' + $t('collectionCenter.site') + '：【' + item.siteName + '】' : '') +
                  (item.driverName ? '；' + $t('order.driver') + '：【' + item.driverName + '】' : '')"
            />
          </el-timeline>
          <div v-if="(!orderItem.vehicleTrack || orderItem.vehicleTrack.length === 0) && (!orderItem.trackStatuses || orderItem.trackStatuses.length === 0)" style="text-align: center">{{ $t('orderCenterCont.NotFound') }}</div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
export default {
  name: 'TrackDetail',
  props: {
    trackData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    trackIcon: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      activeName: 0
    };
  }
};
</script>

<style>
.timelineItem .el-timeline-item__timestamp.is-bottom {
  margin-top: 0;
  padding-top: 4px
}
.timelineItem .el-timeline-item__node--normal,
.timelineItem .el-timeline-item__tail
{
  top: 1px;
}
.timelineItem .el-timeline-item__timestamp {
  color: #5c5f65;
  font-size: 14px;
}
.color-brand-primary {
  color: #00A551;
}
.color-f5bc17 {
  color: #f5bc17;
}
.color-20a8b0 {
  color: #20a8b0;
}
.color-b00e85 {
  color: #b00e85;
}
.color-67C23A {
  color: #67C23A;
}
.color-c72121 {
  color: #c72121;
}
</style>
